<template>
  <div class="lang-switcher">
    <button
      v-show="lang === 'en'"
      @click="setCookies('ru')"
      class="lang-switcher_button"
      :class="[{'lang-switcher_button--active' : lang === 'en', bold}, color]"
    >РУС
    </button>
    <button
      v-show="lang === 'ru'"
      @click="setCookies('en')"
      class="lang-switcher_button"
      :class="[{'lang-switcher_button--active' : lang === 'en', bold}, color]"
    >ENG
    </button>
  </div>
</template>

<script>
export default {
  name: 'change_lang',
  data () {
    return {
      lang: 'ru',
    }
  },
  props: {
    bold: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: "grey",
      validator(val) {
        return [
          "grey",
          "black",
        ].includes(val)
      }
    }
  },
  created () {
    this.checkCookies()
  },
  methods: {
    checkCookies () {
      const lang = window.location.href.match(/lang=([a-zA-Z]+)/)
      
      if (lang) {
        this.lang = lang[1]
        this.$i18n.set(lang[1])
        return
      }

      const matches = document.cookie.match(new RegExp(
        '(?:^|; )' + '_user_language_'.replace(/([.$?*|{}()\[\]\\\/+^])/g, '\\$1') + '=([^;]*)',
      ))

      if (matches) {
        this.lang = decodeURIComponent(matches[1])
      }
    },
    setCookies (value) {
      if (this.lang !== value) {
        this.$i18n.set(this.lang)

        const options = {
          expires: 3600,
          path: '/',
          domain: '',
        }

        options.domain = window.location.host.split('.').reverse().slice(0, 2).reverse().join('.')
        // console.log(options.domain)
        let expires = options.expires

        if (typeof expires == 'number' && expires) {
          const d = new Date()
          d.setTime(d.getTime() + expires * 24 * 90)
          expires = options.expires = d
        }
        if (expires && expires.toUTCString) {
          options.expires = expires.toUTCString()
        }

        value = encodeURIComponent(value)

        let updatedCookie = '_user_language_=' + value

        for (const propName in options) {
          updatedCookie += '; ' + propName
          const propValue = options[propName]
          if (propValue !== true) {
            updatedCookie += '=' + propValue
          }
        }

        localStorage.setItem('_user_language_', value)
        document.cookie = updatedCookie
        location.reload()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";
@import "./src/front_white/sass/components/mixins";
@import './src/front_white/sass/components/settings';

.lang-switcher {
  width: 25px;

  &_button {
    font-size: 12px;

    &.grey {
      opacity: 0.6;
    }

    &.bold {
      font-weight: bold;
    }

    &--active {
      color: $active;
    }

    &:hover {
      color: $active;
    }
  }
}
</style>
